import gql from 'graphql-tag';

export default gql`
    mutation SpillBox($input: SpillBoxInput) {
        spillBox(input: $input) {
            errors
        }
    }
`;
